import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { FormLayout } from "../common/FormLayout";

export const ForgotPasswordConfirmationPage = () => {
  const { t } = useTranslation();
  return (
    <FormLayout title={t("forgot-password-email-sent-title")}>
      <div className="text-center space-y-6">
        <div className="text-secondary-text">
          <FontAwesomeIcon icon="envelope" size="3x" />
        </div>

        <div className="inline-block bg-secondary-text p-6 rounded-lg">
          <p className="text-tertiary font-oxaniumMedium">
            {t("forgot-password-email-sent-message")}
          </p>
        </div>

        <p className="text-tertiary text-sm">
          {t("forgot-password-email-sent-hint")}
        </p>

        <div className="mt-8">
          <a href="/login" className="text-tertiary hover:underline">
            {t("forgot-password-back-to-login")}
          </a>
        </div>
      </div>
    </FormLayout>
  );
};
